import IStory from '#/types/stories';

export const StoryDetailsActionType = {
  STORY_DETAILS_SET_STORY_DETAILS: 'story_details/set_story_details',
} as const;

export type TStoryDetailsActions = {
  type: typeof StoryDetailsActionType.STORY_DETAILS_SET_STORY_DETAILS;
  payload: IStory | undefined;
};
